/*
 * useAccountHooks.js
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Feb 02 2023 mys Company
 */

import { useMutation } from "@tanstack/react-query";
import { axiosInstance, Methods } from "../../../config/axios/Axios";

export const useLogin = () => {
  let version = "v1";
  const serviceCall = async (body) => {
    const response = await axiosInstance(version, "login", null, Methods.POST, {}, body);
    return response;
  };

  const { mutate: loginService } = useMutation({
    mutationFn: serviceCall,
  });
  return { loginService };
};

export const useOTP = () => {
  let version = "v1";
  const serviceCall = async (body) => {
    const response = await axiosInstance(version, "activation", null, Methods.POST, {}, body);
    return response;
  };

  const { mutate: loginService } = useMutation({
    mutationFn: serviceCall,
    onSuccess: () => {
      //navigate("/");
    },
  });
  return { loginService };
};
